import Composition, { CompositionElement } from "@domain/composition/Composition";
import Group from "@domain/composition/Group";
import Space from "@domain/composition/Space";

export default class CompositionFactory {
    static getComposition(elements: CompositionElement[] | Group, parent?: Space, virtual?, attributes?, compositionNumber?: Number, dataComposition?: any): Composition{
        return new Composition(elements,parent,null,null,null, dataComposition);
    }

}
